import useStoreConfigController from '@/components/config-editor/hooks/useStoreConfigController';
import { ImageUpload } from '@/components/form';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import ImagePlaceholder from './ImagePlaceholder';

interface StoreConfigImageProps {
  value: string;
  onChange: (value: string) => void;
  path?: string;
  onFocus?: (id: string, value: string) => void;
  id: string;
}

function StoreConfigImage({ path = 'brandLogo', value, onChange, onFocus, id }: StoreConfigImageProps) {
  const { baseValue, isBaseDifferent, restoreBaseValue } = useStoreConfigController({
    path,
    onChange,
    value,
  });

  const handleFocus = (value: string) => {
    onFocus?.(id, value);
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        {value ? <img className="h-auto w-40" src={value} alt="Store config image" /> : <ImagePlaceholder />}
        <div className="flex flex-grow flex-col gap-2">
          <Input
            id={id}
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
            onFocus={(e) => handleFocus(e.target.value)}
          />
          <ImageUpload url={value} onImageAvailable={(url) => onChange?.(url)} />
        </div>
      </div>
      {isBaseDifferent && (
        <div className="flex items-center gap-2">
          <p>Store config value:</p>
          <div className="flex items-center gap-2">
            <img title={baseValue} className="h-auto w-20" src={baseValue} alt="Store config image" />
            <Button variant="link" onFocus={(e) => handleFocus(baseValue)} onClick={restoreBaseValue}>
              Use store config value
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}

export default StoreConfigImage;
